import React, { Component } from 'react';
// import Link from './components/Link';
// import { TransitionGroup, CSSTransition } from 'react-transition-group';
import axios from 'axios';
// import Icon from './components/Icon';
import { BrowserRouter as Router, Route } from 'react-router-dom';
//
// import Main from './views/Main';
import Page from './pages/Page';
import Nav from './components/Nav';
import Copy from './components/ui/Copy';

export const DEFAULT_PAGE = '/Works';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pages: null,
      routes: null
    };
  }
  componentDidMount() {
    this.getData();
  }
  componentWillUnmount() {
    this.serverRequest.abort();
  }
  getData() {
    this.serverRequest = axios.get('./data/data.json').then(result => {
      const pages = result.data.pages;
      this.setState({
        pages: pages,
        routes: this.getRoutes(pages)
      });
    });
  }
  getRoute(route, subRoute) {
    const curRoute = subRoute ? subRoute : route;
    return {
      link: curRoute.link,
      path: this.getPathToLink(route, subRoute),
      subRoute: subRoute,
      page: curRoute,
      parent: route
    };
  }
  getRoutes(pages) {
    let routes = [];
    if (pages && pages.length > 0) {
      pages.forEach(route => {
        routes.push(this.getRoute(route));
        if (route.sublinks) {
          route.sublinks.forEach(sublink => {
            routes.push(this.getRoute(route, sublink));
          });
        }
      });
    }
    // console.log(routes);
    return routes;
  }
  getPathToLink(route, subRoute) {
    const path = route.path === '/' ? DEFAULT_PAGE : route.path;
    return subRoute ? path + subRoute.path : route.path;
  }
  getImage(img, large) {
    return `./imgs/${img.folder}${img.large && large ? '/large' : ''}/${
      img.name
    }.${img.type}`;
  }
  render() {
    const { routes } = this.state;
    const { pages } = this.state;
    return (
      <Router>
        {routes &&
          routes.length && (
            <div className="main wrapper wrapper--with-paddings">
              <Nav
                routes={pages}
                getPathToLink={this.getPathToLink.bind(this)}
                hideSubRoutes
              />
              <main>
                {routes.map((route, i) => (
                  <Route
                    path={route.path}
                    render={() => (
                      <Page
                        getPath={this.getPathToLink}
                        getImage={this.getImage}
                        page={route.page}
                        parent={route.parent}
                      />
                    )}
                    key={i}
                    exact
                  />
                ))}
              </main>
              <footer className="margin-top--huge">
                <div className="">
                  <Copy className="" text="Copyright Jenni Toikka 2023" />
                </div>
              </footer>
            </div>
          )}
      </Router>
    );
  }
}
export default App;



// WEBPACK FOOTER //
// ./src/App.js